import { ConfigurationModeText } from './ConfigurationModeText';

export default ConfigurationModeText;
